import { render, staticRenderFns } from "./instrumentlib.vue?vue&type=template&id=4a7b7065&scoped=true&"
var script = {}
import style0 from "./instrumentlib.vue?vue&type=style&index=0&id=4a7b7065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7b7065",
  null
  
)

export default component.exports